import { CSSProperties } from "react";
import { SpotifyArtistInBrandConnections, SpotifyArtistSearchResponse } from "modules/Types";
import ArtistItem from "./ArtistItem";
import { clsx, styx } from 'modules/Utils';
import Sty from "modules/Sty";

interface Props {
  style?: CSSProperties;
  className?: string;
  artists: (SpotifyArtistInBrandConnections | SpotifyArtistSearchResponse)[];
  selectArtist: (artist: SpotifyArtistInBrandConnections | SpotifyArtistSearchResponse) => void;
  selectedArtist: SpotifyArtistInBrandConnections | SpotifyArtistSearchResponse | null;
  isLoadingSelectedArtist?: boolean;
}

/**
 * ArtistList component displays a scrollable list of artists with selection functionality
 * @param props - Component props
 * @returns ArtistList component
 */
const ArtistList = ({
  className,
  style,
  artists,
  selectArtist,
  selectedArtist,
  isLoadingSelectedArtist,
}: Props) => {
  return (
    <div
      className={clsx('artistListComponent', className)}
      style={sty.artistListComponent}
    >
      {artists.map((artist, index) => {
        const isSelected = selectedArtist?.id === artist.id;

        return (
          <ArtistItem
            key={`${artist.id}-${index}`}
            className={clsx("fromArtistListComponent", className)}
            style={styx(style)}
            isLoadingSelectedArtist={isLoadingSelectedArtist}
            isSelected={isSelected}
            artist={artist}
            selectArtist={selectArtist}
            buttonLabel="Connect"
          />
        );
      })}
    </div>
  );
};

const sty: Record<string, CSSProperties> = {
  artistListComponent: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 8,
    overflowY: 'auto'
  },
  artistListLine: {
    height: 0,
    border: Sty.border,
    flex: 'none',
    alignSelf: 'stretch'
  }
}

export default ArtistList;
